import { v7 as uuidv7, validate as uuidValidate } from "uuid";
import { z } from "zod";

/** All ids are UUIDv7 text (time-ordered, sortable). */
export function newId(): string {
  return uuidv7();
}

export function isUuid(value: string): boolean {
  return uuidValidate(value);
}

/** Any RFC 4122 UUID; fixtures use hand-written ids, production uses v7. */
export const uuidSchema = z.string().refine(isUuid, { message: "Invalid id" });

/** ISO 8601 UTC timestamp string (CLAUDE.md rule 7). */
export function isoNow(): string {
  return new Date().toISOString();
}

export const isoDateTimeSchema = z
  .string()
  .refine((s) => !Number.isNaN(Date.parse(s)) && s.endsWith("Z"), {
    message: "Expected an ISO 8601 UTC timestamp ending in Z",
  });
